export const data = {


    scene: '03_sauvojenPituus',
    kysymysteksti: 'Säädä sauvat Pentille sopivaksi.',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'Sauvat säädetty aivan liian matalalle',
            valinta: 'sauvat matala plusplus',
            ohjaajan_palaute: 'Sauvat on säädetty aivan liian lyhyiksi - selkä rasittuu tuommoisessa touhussa',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_sauvojen_pituus_ei_sopiva',
            harjoiteltava: ['apuvälineasioita'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija ohjaa apuvälineiden ja hyvinvointia tukevan teknologian käytössä ja huollossa',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'ohjaa apuvälineiden käytössä',
                            toteutui: 'ei'
                        }
                    ]
                }
            ]
        },

        {
            id: 2,
            teksti: 'Sauvat säädetty hieman liian matalalle',
            valinta: 'sauvat matala plus',
            ohjaajan_palaute: 'Sauvat on säädetty hieman liian lyhyiksi - tuokin rasittaa selkää pidemmän päälle',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_sauvojen_pituus_ei_sopiva',
            harjoiteltava: ['apuvälineasioita'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija ohjaa apuvälineiden ja hyvinvointia tukevan teknologian käytössä ja huollossa',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'ohjaa apuvälineiden käytössä',
                            toteutui: 'ei'
                        }
                    ]
                }
            ]
        },
        {
            id: 3,
            teksti: 'Sauvat säädetty sopivalle pituudelle',
            valinta: 'sauvat sopivat',
            ohjaajan_palaute: 'Hienoa, osasit säätää sauvat oikean mittaisiksi.',
            koontiteksti: '',
            pisteet: 1,
            arviointitiedosto: 'scene_03_sauvojen_pituus_ok',
            harjoiteltava: [],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija ohjaa apuvälineiden ja hyvinvointia tukevan teknologian käytössä ja huollossa',
                    osaamistaso: 1,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'ohjaa apuvälineiden käytössä',
                            toteutui: 'kyllä'
                        }
                    ]
                }
            ]
        },
        {
            id: 4,
            teksti: 'Sauvat säädetty liian pitkiksi',
            valinta: 'sauvat korkea plus',
            ohjaajan_palaute: 'Nyt sauvat on säädetty liian pitkiksi - tuo käy hartioihin ja olkapäihin',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_sauvojen_pituus_ei_sopiva',
            harjoiteltava: ['apuvälineasioita'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija ohjaa apuvälineiden ja hyvinvointia tukevan teknologian käytössä ja huollossa',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'ohjaa apuvälineiden käytössä',
                            toteutui: 'ei'
                        }
                    ]
                }
            ]
        }


    ]


};